var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(
      !_vm.form.approvalStatus ||
        _vm.form.approvalStatus === 'Editting' ||
        _vm.form.approvalStatus === 'Draft'
    )?[_c('TrinhDuyetBtn',{attrs:{"form":_vm.form}})]:(_vm.form.approvalStatus === 'Pending')?[_c('PheDuyetBtn',{attrs:{"form":_vm.form}})]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }